export default __webpack_public_path__ + "static/media/burton.93b25197.gif";